/**
 * Where a visitor is allowed to be without a session.
 *
 * `PublicPages` lists exact paths, which cannot express a route that carries a
 * parameter. The patient share link is exactly that: /shared/<token>. Anything
 * that has to answer "may this person be here signed out?" reads it from here,
 * so the router, the 401 interceptor and the providers that mount above the
 * router cannot drift apart on the answer.
 *
 * Deliberately free of imports: it is pulled in by apiHelper, which sits below
 * almost everything else.
 */

export const SHARED_REPORT_PREFIX = '/shared/';

/** True on a patient-facing share link, which no signed-in user is required for. */
export function isSharedReportPath(pathname: string): boolean {
  return (
    pathname.startsWith(SHARED_REPORT_PREFIX) &&
    pathname.length > SHARED_REPORT_PREFIX.length
  );
}

export const SIGNUP_PREFIX = '/signup';

/** True on the training portal sign-up, or its landing page at the root, which a visitor starts signed out. */
export function isSignupPath(pathname: string): boolean {
  return pathname === '/' || pathname === SIGNUP_PREFIX || pathname.startsWith(`${SIGNUP_PREFIX}/`);
}
